import React, { forwardRef } from 'react';
import { upperFirstChar } from '../../utils/text/upperFirstChar';
function createTextComponent(Text, elementType, defaultProps, displayName) {
    const TextComponent = forwardRef((props, ref) => (React.createElement(Text, { elementType: elementType, ...defaultProps, ...props, ref: ref })));
    TextComponent.displayName =
        displayName || `Text.${upperFirstChar(elementType)}`;
    return TextComponent;
}
export function textComponentFactory(Component, elementType) {
    if (elementType) {
        return (defaultProps, displayName) => createTextComponent(Component, elementType, defaultProps, displayName);
    }
    return (elementType, defaultProps, displayName) => createTextComponent(Component, elementType, defaultProps, displayName);
}
//# sourceMappingURL=TextUtils.js.map